module.exports = __webpack_public_path__ + "img/hos_cert_img_bg.a4364b72.png";